class CExclusiveReleases extends HTMLElement {
  constructor() {
    super();
    this.cards = [];
    this.currentIndex = 0;
    this.animating = false;
  }

  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('.c-exclusive-releases__card'));
    if (this.cards.length === 0) return;

    this.track = this.querySelector('.c-exclusive-releases__cards');
    this.currentIndex = Math.floor(this.cards.length / 2);

    this.querySelectorAll('.c-exclusive-releases__arrow').forEach((btn) => {
      btn.addEventListener('click', () => {
        this.go(btn.dataset.direction === 'next' ? 1 : -1);
      });
    });

    this.cards.forEach((card) => {
      card.addEventListener('click', () => {
        if (card.classList.contains('is-prev')) this.go(-1);
        else if (card.classList.contains('is-next')) this.go(1);
      });
    });

    this.update();
  }

  go(step) {
    if (this.animating) return;
    const len = this.cards.length;
    const next = (this.currentIndex + step + len) % len;

    if (!this.track) {
      this.currentIndex = next;
      this.update();
      return;
    }

    // Fade-and-slide the track out in the travel direction, swap state,
    // then slide it back in from the opposite side.
    this.animating = true;
    this.track.classList.add(step > 0 ? 'is-leaving-next' : 'is-leaving-prev');
    setTimeout(() => {
      this.currentIndex = next;
      this.update();
      this.track.classList.add('is-swapping');
      this.track.classList.remove('is-leaving-next', 'is-leaving-prev');
      this.track.classList.add(step > 0 ? 'is-leaving-prev' : 'is-leaving-next');
      void this.track.offsetWidth;
      this.track.classList.remove('is-swapping');
      this.track.classList.remove('is-leaving-next', 'is-leaving-prev');
      setTimeout(() => {
        this.animating = false;
      }, 200);
    }, 200);
  }

  update() {
    const len = this.cards.length;
    const prevIdx = (this.currentIndex - 1 + len) % len;
    const nextIdx = (this.currentIndex + 1) % len;

    this.cards.forEach((card) => {
      card.classList.remove('is-prev', 'is-center', 'is-next');
      card.style.order = '';
    });

    this.cards[this.currentIndex].classList.add('is-center');
    this.cards[this.currentIndex].style.order = '0';
    if (len > 1) {
      this.cards[prevIdx].classList.add('is-prev');
      this.cards[prevIdx].style.order = '-1';
    }
    if (len > 2) {
      this.cards[nextIdx].classList.add('is-next');
      this.cards[nextIdx].style.order = '1';
    }
  }
}

customElements.define('c-exclusive-releases', CExclusiveReleases);
